'use strict';

(function () {

const self = Fotobook.import = {
    uploadProviderPreviewPromise: null, // Upload photos ajax request
    ps_xhr: null,
    STATUS_NEW: 0,
    STATUS_SELECTED: 1,
    STATUS_ERROR: 2,
    CODE_MYCOMPUTER: 'mycomputer',

    uploaderSelector: '#fotobookUpload',
    originalFiles: [],
    aborted: false,
    album_id: 0,
    uploading: {},
    canvas : {
        canvas: null,
        get() {
            if (this.canvas === null) {
                this.canvas = document.createElement('canvas');
            }
            return this.canvas;
        },
        free() {
            const canvas = this.get();
            canvas.width=0;
            canvas.height=0;
            canvas.getContext('2d').clearRect(0,0,canvas.width,canvas.height);
        },
    },
    img: {
        img    : null,
        locked : false,
        get() {
            if (this.locked) {
                console.error('Attempt to get locked img!');
                return null;
            }
            if (this.img === null) {
                this.img = document.createElement('img');
            }
            this.locked = true;
            return this.img;
        },
        free() {
            this.img.onload = null;
            this.img.onerror = null;
            window.URL.revokeObjectURL(this.img.src);
            this.img.src = '';
            this.locked = false;
        },
    },
    check_upload_dialog_timeout: false,
    background_upload_active: false,

    /**
     * Типы фото разрешенные для загрузки
     */
    allowedMimeTypes: ['image/jpeg', 'image/png'],
    setBackgroundUploadActive(value) {
        value = !!value;
        if (self.background_upload_active !== value) {
            self.background_upload_active = value;
            $('html').toggleClass('background-upload', value);
            $(document).trigger(Fotobook.events.BACKGROUND_UPLOAD, value);
        }
    },
    backgroundUploadActive() {
        return self.background_upload_active;
    },

    /** Флаг активности процесса генерациии превью при локальной загрузке */
    local_processing_active: false,

    setLocalProcessingActive(value) {
        value = !!value;
        if (self.local_processing_active !== value) {
            self.local_processing_active = value;
            self.checkUploadDialogButtons();
        }
    },

    localProcessingActive() {
        return self.local_processing_active;
    },

    /**
     * Показать диалог загрузки изображений
     */
    showImportDialog(data) {
        return new Promise((resolve, reject) => {
            const tooltipZindex = $.fn.qtip.zindex; // zindex для подсказок
            $.fn.qtip.zindex += 100; // отображать тултипы поверх диалога
            if (self.backgroundUploadActive() || $('#import').length) {
                Fotobook.notification.showWarning(t('photobook-js-warning-lostphoto'));
                return;
            }
            data = $.extend({
                class    : Fotobook.ClipartType.FOTO,
                album_id : 0,
                local_ids : self.getAvailableLocalIds(),
            }, data);
            const clipartType = data['class'];
            $('<div id="uploadFotoDialog"></div>').dialog({
                title: t('photobook-js-importDialogTitle'),
                autoOpen: false,
                width: 1008,
                height: 640,
                modal: true,
                resizable: false,
                dialogClass: 'upload-foto-dialog fotobook-dialog',
                buttons: [
                    {
                        id: 'uploadFotos',
                        class: 'disabled fotobook_button functional-button',
                        text: t('photobook-js-buttonsAddPhotos'),
                        click() {
                            self.clickUploadClipartButton().then(() => {
                                $(this).dialog('close');
                            }).catch(() => {});
                        },
                    },
                    {
                        id: 'cancelUploadFotos',
                        class: 'fotobook_button neutral-button',
                        text: t('photobook-js-buttonsCancel'),
                        click() {
                            $(this).dialog('close');
                        },
                    },
                ],
                create() {
                    const $dialog = $(this);
                    Fotobook.ajax.postHTML('/photos/import/get-upload-dialog-content', {
                        data,
                        longQueryTimeout : 0,
                    }).then((response) => {
                        $dialog.html(response).dialog('open');
                        self.init();
                        const guest = !Fotobook.store.state.user.id;
                        if(guest || clipartType !== Fotobook.ClipartType.FOTO) {
                            $('.mobile-section').hide();
                        }
                        //инициализация jsp скролла
                        $('.auto-jsp', $dialog).each(function () {
                            setTimeout(() => $(this).initJsp(), 0);
                        });
                    });
                },
                open() {
                    // [FOT-5535] фикс для заглушки моб. редактора
                    $('.ui-widget-overlay:first').addClass('upload-photo-overlay');

                    const $dialog = $(this);
                    Fotobook.ajax.getHTML('/photos/import/get-user-quota', {}).then((response) => {
                        const $html = $(response).prepend(t('photobook-profile-quotaTitle')+': ');
                        $dialog.after($html);
                    }).catch(() => {});
                },
                beforeClose() {
                    $.fn.qtip.zindex = tooltipZindex; // восстановить значение слоя
                    if ($('#cancel').hasClass('disabled')) {
                        return false;
                    }
                },
                close() {
                    $('.ui-tooltip').hide();
                    try{
                        $('.upload-foto-dialog').dialog('destroy'); // Не уверен, что это нужно. Оставлю пока что
                    } catch(e) {}
                    $(this).dialog('destroy');
                    Fotobook.fotoManager.getTotalCountFotos();
                    // после пересмотра загрузчика переделать
                    if (data.class !== Fotobook.ClipartType.FOTO) {
                        Fotobook.store.dispatch('userClipart/updateUserClipart');
                    }
                    resolve();
                },
            });
        });
    },
    /**
     * Кнопка старта загрузки в диалоге импорта фотографий
     */
    clickUploadClipartButton() {
        if ($('#uploadFotos').hasClass('disabled')) {
            return Promise.reject();
        }
        const $import = $('#import');
        const upload_class = $import.attr('data-upload-class');
        const albumID = parseInt($import.attr('data-album-id'), 10) || 0;

        return self.createClipartFromSessionFotos({
            album_id: albumID,
            class: upload_class,
        }).then(() => {

            self.backgroundUpload({
                class: upload_class,
            });
        });
    },
    requestCreateClipartData(clipart_class, element) {
        return new Promise((resolve, reject) => {
            const data = {
                id : parseInt(element.getAttribute('data-id'), 10),
            };

            if (clipart_class !== 'Frames') {
                resolve(data);
                return;
            }
            Fotobook.frame.getPoints(element).then((frame_data) => {
                resolve($.extend(data, frame_data));
            }).catch(reject);
        });
    },
    getCreateClipartData(upload_class) {
        return new Promise((resolve, reject) => {
            let i=0;
            const clipart_data = {};
            const $fotos = $('.added-fotos-section').find('[data-id]');
            const next = () => {
                if (i >= $fotos.length) {
                    resolve(clipart_data);
                    return;
                }
                const element = $fotos[i++];
                self.requestCreateClipartData(upload_class, element).then((data) => {
                    clipart_data[element.getAttribute('data-id')] = data;
                    next();
                }).catch(() => {
                    reject(clipart_data);
                });
            };

            next();
        });
    },
    abortPSRequest() {
        if (self.ps_xhr && self.ps_xhr.abort) {
            self.ps_xhr.abort();
            self.ps_xhr = null;
        }
    },
    abortCreateClipartFromSessionFotos() {
        if (self.uploadProviderPreviewPromise && self.uploadProviderPreviewPromise.abort) {
            // не работает, т.к. Promise не имеет метода .abort(), но пока оставляю, как было
            self.uploadProviderPreviewPromise.abort();
        }

        // приравниваем к null, это позволит нам в дальнейшем сделать проверку на отмену:
        // хоть сам промис отменить нельзя, мы просто остановим последующие запросы к серверу
        self.uploadProviderPreviewPromise = null;

        // делаем кнопку отмены неактивной сразу, хоть это ни на что и не влияет
        $('.cancel-upload-photos').attr('disabled', true).addClass('disabled');
    },

    /**
     * Действия после отмены загрузки фото.
     *
     * @param {array} cancelledPhotos
     */
    cancelPhotosUploading(cancelledPhotos) {
        // очищаем также блок с превью фото
        const $addedContainer = $('.added-fotos-section').find('#added-photos');
        $addedContainer.find('.photo').each(function () {
            $(this).remove();
        });

        // важно: для корректного отображения кол-ва фото нужно вызывать данный метод после очищения списка фото
        self.updateSessionFotosLayout(cancelledPhotos);
    },

    _create_clipart_from_preview_dialog: [
        '<div id="loader" class="core-text-13">',
            '<p>', t('photobook-js-uploadingPhotoFiles'), ': ', ' <span id="total">{count}</span></p>',
            '<img alt="" class="foto-copy-ajax-loader"  src="/images/ajax-file-loader.gif">',
        '</div>',
    ].join(''),
    /**
     * Небольшое окошко, висит пока создаётся клипарт из SessionResources
     */
    showUploadClipartDialog(count) {
        return $(['<div class="upload-photo-dialog">', self._create_clipart_from_preview_dialog.supplant({
            count,
        }, '</div>')].join('')).dialog({
            title: t('photobook-js-uploadDialogTitle'),
            width: 350,
            modal: true,
            autoResize: true,
            autoOpen: true,
            resizable: false,
            closeOnEscape: false,
            position: {
                my: 'center',
                at: 'center',
                of: '.available-fotos-section',
                collision: 'fit',
                using() {
                     const params = {
                             top: '250px',
                             left: 'calc(50% - 190px)',
                         };
                     if (!Fotobook.onlineEditorActive()) {
                         params.position = 'fixed';
                     }
                     $(this).css(params);
                },
            },
            dialogClass: 'fotobook-dialog editor upper-dialog no-close',
            beforeClose: self.abortCreateClipartFromSessionFotos,
            close() {
                $(this).html('').dialog('destroy');
            },
            buttons: [{
                text: t('photobook-js-buttonsCancel'),
                class: 'fotobook_button neutral-button cancel-upload-photos',
                click: self.abortCreateClipartFromSessionFotos,
            }],
        });
    },
    createClipartFromSessionFotos(data) {
        data = {
            class: Fotobook.ClipartType.FOTO,
            album_id: 0,
            ...data,
        };

        return new Promise((resolve, reject) => {
            self.getCreateClipartData(data['class']).then((clipart_data) => {
                const len = Object.keys(clipart_data).length;
                if (!len) {
                    Fotobook.notification.showWarning(t('photobook-js-selectFotos'));
                    reject();
                    return;
                }
                data.clipart_data = clipart_data;

                const $dialog = self.showUploadClipartDialog(len);
                self.createClipartFromSessionFotosAjax(data).then(() => {
                    $(document).trigger('clipart-uploaded', {
                        clipart_class : data['class'],
                        album_id : data.album_id,
                    });
                    resolve();
                }).catch(reject).finally(() => {
                    $dialog.dialog('destroy');
                });
            }).catch(reject);
        });
    },
    createClipartFromSessionFotosAjax(data) {
        return new Promise((resolve, reject) => {
            self.uploadProviderPreviewPromise = Fotobook.ajax.postJSON('/photos/import/create-clipart-from-session-resources', {
                data,
                timeout: 0,
                queue: false,
            }).then((response) => {
                // если юзер отменил загрузку, а затем загружает те же изображения снова, - массив будет пустой
                self.markLocalFilesForUpload(response.data.swf_id_map);
                if (response.data.errors) {
                    Fotobook.notification.showError(response.data.errors);
                    throw new Error();
                }
                if (!self.uploadProviderPreviewPromise) {
                    // загрузка была отменена, дальше ничего не делаем
                    // после этого кнопка "удалить все" не работает, т.к. сервер не возвращает
                    // необходимые данные, чтобы сделать очистку; посему лепим данный костыль для очистки списка
                    const cancelledPhotos = Object.entries(response.data.swf_id_map).map((item) => {
                        return {
                            id: item[1].id,
                            swf_file_id: item[0],
                            status: self.STATUS_NEW,
                        };
                    });
                    self.cancelPhotosUploading(cancelledPhotos);

                    throw new Error('abort');
                }
                //Fotobook.core.getAlbumFotos(); // !!! временное решение, нужно сделать обновление фотоколлекции в нижнем меню более умным способом
                return Fotobook.store.dispatch('FotoManager/loadUserFotos');
            }).then(() => {
                resolve();
            }).catch((jqXHR, textStatus) => {
                // т.к. мы можем пробросить отмену запроса вручную (throw Error('abort')), добавляем доп. проверку
                if (textStatus === 'abort' ||
                    jqXHR instanceof Error && jqXHR.message === 'abort'
                ) {
                    setTimeout(() => {
                        Fotobook.ajax.post('/photos/import/abort-upload', {
                            queue : false,
                        }).catch(() => {}).finally(reject);
                    }, 1000); // есть баг, если сразу абортнуть основной запрос то действия этого запроса срабатывают раньше чем основого. Пока что не знаю как решить. ??? актуален ли коммент?
                }
                reject();
            });
        });
    },
    _foto_tmpl: [
        '<li class="photo">',
            '<span class="added-image-wrapper">',
                '<span class="selected image-controls-hover">',
                    '<img data-id="{id}" class="album_image coloured-border" src="{url}" alt="" rel="noopener noreferrer nofollow" data-swf_file_id="{swf_file_id}" data-foto_storage_code="{foto_storage_code}" data-info=\'{image-info}\'>',
                    '<span class="image-control close remove sprite-image"></span>',
                '</span>',
            '</span>',
            '<span class="foto-name ajax-tooltip core-text-11" data-qtip-text="{original_name-qtip}">{original_name-html}</span>',
        '</li>',
    ].join(''),

    /**
     *
     * @param data
     * @returns {*}
     */
    renderAddedFoto(data) {
        let originalNameHTML = data.original_name.escapeHtml(),
            imageInfo = {
                dimension : `${data.width} x ${data.height} px`,
                size: data.size,
                name: originalNameHTML,
            };

        return self._foto_tmpl.supplant({
            id: data.id,
            url: data.url,
            'original_name-html': originalNameHTML,
            'original_name-qtip': originalNameHTML.escapeHtml(),
            swf_file_id: encodeURIComponent(data.swf_file_id || ''),
            foto_storage_code: data.foto_storage_code,
            'image-info': JSON.stringify(imageInfo),
        });
    },

    changeSelFotosHeader(provider) {
        if (provider === self.CODE_MYCOMPUTER) {
            provider = t('photobook-js-create-localPC');
        }
        $('.available-fotos-section .create-steps-header .text span').html(provider);
    },

    /**
     *  Add all available photos on page to import
     */
    addAll() {
        const data = {};
        $('#photos-list .selectable:not(.selected)').find('.album_image:not(.brokenPhoto)').each(function () {
            const id = parseInt(this.getAttribute('data-id'), 10) || 0;
            data[id] = {
                status: self.STATUS_SELECTED,
            };
        });
        self.UpdateSessionFotos(data);
    },
    removeAll() {
        const data = {};
        self.removeLocalUploadBars(['error', 'warning']);
        $('.added-fotos-section').find('[data-id]').each(function () {
            const id = parseInt(this.getAttribute('data-id'), 10) || 0;
            if (id) {
                data[id] = {
                    status : self.STATUS_NEW,
                };
            }
        });
        if (Object.keys(data).length) {
            self.UpdateSessionFotos(data);
        }
    },
    UpdateSessionFotos(data) {
        if (!Object.keys(data).length) {
            return $.Deferred().resolve().promise();
        }

        Fotobook.ajax.postJSON('/photos/import/update-session-fotos', {
            data: {
                session_fotos : data,
            },
        }).then((response) => {
            self.updateSessionFotosLayout(response.data.session_fotos);
        });
    },
    updateSessionFotosLayout(session_fotos) {
        let $available_section = $('.available-fotos-section'),
            $added_section = $('.added-fotos-section'),
            $added_container = $added_section.find('#added-photos'),
            append = [];

        for (const id in session_fotos) {
            if (!session_fotos.hasOwnProperty(id)) {
                continue;
            }
            let session_foto = session_fotos[id],
                status = session_foto.status,
                $added_foto = $added_container.find(`.album_image[data-id=${id}]`).closest('.photo'),
                $available_foto = $available_section.find(`.album_image[data-id=${id}]`);

            $available_foto.closest('.selectable')
            .toggleClass('selected', session_foto.status !== self.STATUS_NEW)
            ;
            if (status === self.STATUS_NEW) {
                $added_foto.remove();
                self.removeFile(session_foto.swf_file_id);
            } else {
                const new_foto = self.renderAddedFoto(session_foto);
                if ($added_foto.length) {
                    // update existing
                    $added_foto.replaceWith(new_foto);
                } else {
                    // mass append is much faster
                    append.push(new_foto);
                }
            }
        }
        if (append.length) {
            $added_container.append(append.join(''));
        }
        self.updateFotoStatusesLayout();
    },
    update_foto_timeout: 0,
    updateFotoStatusesLayout() {
        const $added_section = $('.added-fotos-section');
        const count = $added_section.find('.photo').length;

        self._recalcPhotosSizes($added_section);
        $added_section.toggleClass('empty', count==0);
        $('.added-fotos-counter-value').text(count);
        self.checkUploadDialogButtons();

        if (!self.update_foto_timeout) {
            self.update_foto_timeout = setTimeout(function () {
                self.update_foto_timeout = false;
                try {
                    const jsp = $added_section.find('.add-photos-wrapper').data('jsp');
                    jsp.reinitialise();
                } catch(e) {}
            }, 0);
        }
    },

    /**
     * Расчёт размера выбранных фотографий(в MB)
     * @param $added_section
     * @private
     */
    _recalcPhotosSizes($added_section) {
        let imageDiskUsed = 0,
            imageDiskUsedText;

        imageDiskUsed = self.calculateImageDiskUsed($added_section);
        imageDiskUsedText = imageDiskUsed ? `(${this._bytesToMegabytes(imageDiskUsed)} MB)` : '';
        $('.size-selected-photos').text(imageDiskUsedText);
    },
    calculateImageDiskUsed($added_section) {
        let imageDiskUsed = 0;

        $added_section.find('.photo .album_image').each(function (index, data) {
            const getImageInfo = $(data).data('info');
            imageDiskUsed += parseInt(getImageInfo.size, 10);
        });

        return imageDiskUsed;
    },
    removeAdded() {
        const id = parseInt($(this).closest('.photo').find('.album_image').attr('data-id'), 10);

        self.UpdateSessionFotos({
            [id] : {
                status : self.STATUS_NEW,
            },
        });
    },
    toggleAvailableFoto(e) {
        const id = parseInt(this.getAttribute('data-id'), 10);

        self.UpdateSessionFotos({
            [id] : {
                status : $(this).closest('.selectable').hasClass('selected') ? self.STATUS_NEW : self.STATUS_SELECTED,
            },
        });
    },
    /**
     * Получить список фотографий альбома
     *
     * @param data
     * @returns {*}
     */
    updateFotosList(data) {
        self.ps_xhr = Fotobook.ajax.postHTML('/photos/import/get-session-resources', {
            data : $.extend({
                foto_storage: $('#import').attr('data-storage'),
            }, data),
            longQueryTimeout : 0,
        }).then(self.updateFotosContainer);
        self.ps_xhr.catch(() => {});
        return self.ps_xhr;
    },

    getBreadCrumbs(breadcrumbsArray, $parentAlbumId, $parentAlbumName, $currentAlbumId) {
        let newBreadCrumbs = false,
        countBreadcrumbsArray = breadcrumbsArray.length;
        breadcrumbsArray.forEach(function (value, index) {
            if (value['0'] !== $parentAlbumName) {
                newBreadCrumbs = true;
            } else {
                return breadcrumbsArray.splice(index, countBreadcrumbsArray - index);
            }
        });
        if (newBreadCrumbs === true) {
            if ($parentAlbumName !== '') {
                breadcrumbsArray.push([
                    $parentAlbumName, $parentAlbumId, $currentAlbumId,
                ]);
            }
        }
        if ($parentAlbumId === '' && $currentAlbumId === '' && countBreadcrumbsArray > 1) {
            breadcrumbsArray.splice(1, countBreadcrumbsArray-1);
            return breadcrumbsArray;
        }
        return breadcrumbsArray;

    },

    /**
     * Генерировать хлебные крошки для провайдеров
     * todo избавиться от использования кук!!!
     */
    doBreadCrumbs() {
        let breadcrumbs = $('#import .content .breadcrumbs'),
            albumsData = $('.provider-folder-back').data(),
            $parentAlbumName = albumsData.parentAlbumName,
            $currentAlbumId = albumsData.currentAlbumId,
            $parentAlbumId = albumsData.parentAlbumId,
            getBreadCrumbs,
            breadcrumbsArray = Fotobook.$cookies.get('provider-breadcrumbs') || [breadcrumbs.text().split('»')];

        getBreadCrumbs = this.getBreadCrumbs(breadcrumbsArray, $parentAlbumId, $parentAlbumName, $currentAlbumId);
        Fotobook.$cookies.set('provider-breadcrumbs', getBreadCrumbs);

        if (typeof breadcrumbsArray !== 'undefined' && breadcrumbsArray.length > 1) {
            let breadcrumbsSection = '',
                countBreadcrumbs = breadcrumbsArray.length;
            breadcrumbsArray.forEach(function (value, key) {
                let parentAlbumName = value['0'] || (typeof value == 'number' ? value['0'] : value['0'].trim()),
                    currentAlbumId = value['2'] || '';
                if (key === 0) {
                    breadcrumbsSection += `<a href="#" data-album-id=${currentAlbumId}>${
                         parentAlbumName}<a>` + ' » ';
                } else if (key === countBreadcrumbs - 1) {
                    breadcrumbsSection += `<span>${parentAlbumName}</span>`
                } else {
                    breadcrumbsSection += `<a href="#" data-album-id=${currentAlbumId}>${parentAlbumName}<a>` + ' » ';
                }
            });

            breadcrumbs.html(breadcrumbsSection);
        }
    },

    /**
     * Обновить область содержащую фотографии
     *
     * @param response
     */
    updateFotosContainer(response) {
        const avaliableFotosSection = $('.available-fotos-section');
        avaliableFotosSection.find('.content').html(response);
        //инициализация jsp скролла после обновления контента
        avaliableFotosSection.find('.auto-jsp').initJsp();
        self._markDropboxBrokenImages();
        self.doBreadCrumbs();
        self.checkAvailableFotosSectionEmpty();
        self.checkImagesOnBroken();
    },

    _markDropboxBrokenImages() {
        if (Fotobook.$cookies.get('foto_storage') !== 'Dropbox') {
            return;
        }
        const noOriginalBlock = Fotobook.noOriginalTmpl();
        $('li.photo img').each(function () {
            let img = new Image(),
                $this = $(this),
                src = $this.attr('src');

            img.onerror = function () {
                $this.addClass('brokenPhoto');
                $this.parent()
                    .addClass('no-original')
                    .append(noOriginalBlock);
            };
            img.src = src;
        });
    },

    checkAvailableFotosSectionEmpty() {
        const $section = $('.available-fotos-section');
        $section.toggleClass('empty', !$section.find('.photo:not(.photo-dir)').length); // !!!нужно убрать класс photo с каталогов!!!
    },
    checkImagesOnBroken() {
        const $section = $('.available-fotos-section');
        if ($section.find('.brokenPhoto').length >= 1) {
            $section.find('.brokenPhoto').after( function () {
                return Fotobook.noOriginalTmpl();
            });
            $section.find('.image-controls-hover').addClass('no-original');
        }
    },

        /** Функция вызывается при успешном  возврате из провайдера */
        ajaxReloadImport() {
            const stepsLeftMenu = $('#steps-left-menu');
            const toConnect = stepsLeftMenu
                .find('.to-connect')
                .toggleClass('connected')
                .removeClass('not-connected')
            ;
            let storageCode;
            if (toConnect.length) {
                storageCode = toConnect.attr('data-storage-code');
            } else {
                storageCode = Fotobook.$cookies.get('foto_storage', Fotobook.ProviderCode.MY_PC);
            }
            const $lnk = stepsLeftMenu.find(`.provider.connected .${storageCode}`).parent();
            $lnk.click();
        },

    /**
     * Запрос за фотками от провайдера
     *
     * @param photoStorage
     * @returns {*}
     */
    fotoStorageRequest(photoStorage) {
        let isLogged = 1,
            requestID,
            stepsLeftMenu = $('#steps-left-menu');
        self.abortPSRequest();
        if (photoStorage === self.CODE_MYCOMPUTER) {
            const api = $('.wrapper-for-jscrollpane').data('jsp');
            if (api) {
                api.destroy();
            }
            Fotobook.ajax.postHTML('/photos/import/my-computer').then((response) => {
                const fotosSection = $('.available-fotos-section');
                fotosSection.find('.content').html(response);
                //инициализация jsp скролла после обновления контента
                fotosSection.find('.auto-jsp').initJsp();
                stepsLeftMenu.find('.provider').removeClass('is-active-storage');
                stepsLeftMenu.find('.auto-jsp').initJsp();
            });
            return;
        }
        requestID = String(new Date().getTime() / 1000).replace('.', '');
        let input;

        stepsLeftMenu.addClass('show-albums');
        const albumCookieValue = Fotobook.$cookies.get(`${photoStorage}_album`);
        input = stepsLeftMenu.find(`input[value="${albumCookieValue}"]`);
        input.attr('checked', true);
        stepsLeftMenu.find('.provider').removeClass('is-active-storage');
        stepsLeftMenu.find(`.provider[data-storage-code=${photoStorage}]`).addClass('is-active-storage');
        if (input.val() === undefined) {
            stepsLeftMenu.find('input').first().attr('checked', true);
            input.val('');
        }
        self.jspReinitialise();
        Fotobook.$cookies.remove('provider-breadcrumbs');
        self.updateFotosList({
            foto_storage: photoStorage,
            album_id: '',
        }).then(() => {
            if ($('.available-fotos-section .provider-link').length > 0) {
                isLogged = 0;
            }
        }).catch((jqXHR, textStatus, errorThrown) => {
            if (textStatus === 'abort') {
                Fotobook.ajax.post('/photos/import/abort', {
                    data: {
                        requestID,
                    },
                    queue: false,
                });
            }
        });
    },

    jspReinitialise() {
        $('#steps-left-menu').find('.auto-jsp').reinitJsp();
    },

// ----------------- Загрузки одного файла по клику -----------------------------------
    /**
     * Открывает запрос на выбор одного файла, после выбора
     * проверяет квоту, и если ок - выполняет resolve, иначе reject
     * @return Promise
     */
    openSingleFileRequest() {
        if (self.backgroundUploadActive()) {
            Fotobook.notification.showWarning(t('photobook-js-warning-lostphoto'));
            return Promise.reject();
        }

        return new Promise((resolve, reject) => {
            // todo сделать без $.Deferred()
            const deferred = $.Deferred();
            $('#fotobook-uploader-input').removeAttr('multiple').show().css('position', 'fixed').focus().data('importdeferred', deferred).click().hide().css('position', 'absolute');
            deferred.progress((files) => {
                const file = files[0];
                self.checkQuota(file.size).then(
                    () => resolve(file),
                    () => reject()
                );
            });
        });
    },
    /**
     * Клик по кнопке загрузки фото в контейнер/фон
     */
    uploadToContainerClick(e) {
        let ids = [], $container;

        $container = $(this).closest('.foto-container,.bg');
        if ($container.hasClass('bg')) {
            $container = Fotobook.book.getSingleOrSpreadBg($container.find('.bg-content')).find('.bg-content');
        }
        $container.each(function () {
            ids.push(parseInt(this.getAttribute('data-id'), 10));
        });

        if (!ids.length) {
            return;
        }
        self.openSingleFileRequest().then((file) => {
            // прверить формат файла
            const fileType = $.inArray(file.type, self.allowedMimeTypes);
            if (fileType === -1) {
                Fotobook.notification.showWarning(t('photobook-error-invalidFileFormat'));
                return false;
            }
            if (file.size > Fotobook.config.data[Fotobook.Settings.MAX_FILE_SIZE]) {
                Fotobook.notification.showWarning(t('photobook-js-file-maxFilesizeInMb', {
                    megabytes: self._bytesToMegabytes(Fotobook.config.data[Fotobook.Settings.MAX_FILE_SIZE]),
                }));
                return false;
            }
            const $ajaxloader = $container.add($container.closest('.bg')).addClass('ajax-loader');
            self.uploadFotoToContainer(ids, file).catch(() => {}).finally(() => {
                $ajaxloader.removeClass('ajax-loader');
            });
        }).catch(() => {});
    },
    /**
     * Загрузка одного файла в контейнер(ы)
     *
     * @param {[int]} ids - id контейнера
     * @param {string} file - файл для загрузки
     * @return Promise
     */
    uploadFotoToContainer(ids, file) {
        const initObj = {
                id : self.getUniqueID(),
                file,
            };

        return self.createOnePreview(initObj).then((obj) => {
            if (!(obj.data instanceof FormData)) {
                return;
            }
            ids.forEach((id) => obj.data.append('container_ids[]', id));

            //проверяем, ассоциирован ли текущий альбом с проектом...
            if (!Fotobook.isCurrentAlbum()) {
                //...если нет, указываем ассоциированный альбом
                const album = Fotobook.getMarkedAlbum();
                obj.data.append('album_id', album.id);
            }

            return Fotobook.ajax.postJSON('/photos/import/upload-foto-to-container', {
                data : obj.data,
                contentType: false,
                type : 'post',
                dataType : 'json',
                processData : false,
            }).then((response) => {
                const swf_id_map = response.data.swf_id_map;

                if (!swf_id_map[obj.id]) {
                    return;
                }
                Fotobook.book.updateBookFromResponse(response.data);
                return self.uploadSingleOriginal(swf_id_map[obj.id]['class'], swf_id_map[obj.id].id, obj.file);
            });
        });
    },
    /**
     * Загрузка одного отсутствующего оригинала
     *
     * @param {string} clipart_class - Класс клипарта
     * @param {int} id - id клипарта
     * @param {File} file - файл для загрузки
     * @param addParams
     * @return Promise
     */
    uploadSingleOriginal(clipart_class, id, file, addParams) {
        self.setBackgroundUploadActive(true);
        let response;
        return self.backgroundUploadThread({
            id : self.getUniqueID(),
            file,
            swf_id_map : {
                class : clipart_class,
                id,
            },
            addParams,
        }, clipart_class).done((responseData) => {
            response = responseData;
        }).fail(() => {
        }).always(() => {
            Fotobook.book.updateBookFromResponse(response);
            self.setBackgroundUploadActive(false);
            self.uploadComplete();
        });
    },
    /**
     * Клик по элементу загрузки оригинала файла
     * Выполняет проверку квоты и запускает загрузку оригинала
     * @todo возможно не лочить интерфейс через $this.addClass("ajax-loader")
     */
    uploadMissingOriginalClick($image) {
        let $this = $(this),
            id = parseInt($image.length ? $image.data('id') : $this.find('[data-id]').attr('data-id'), 10),
            $parentWrapper = $image.length ? $image.parent('span') : $this,
            $ajaxLoaderImg = $parentWrapper.find('.ajax-loader-img'),
            $noOriginalImage = $parentWrapper.find('.no-original-image'),
            $noOriginalBlock = $parentWrapper.find('.no-original-block')
        ;

        self.openSingleFileRequest().then((file) => {
            $this.addClass('ajax-loader');
            $ajaxLoaderImg.show();
            $noOriginalImage.hide();
            $noOriginalBlock.show();

            self.uploadSingleOriginal(Fotobook.ClipartType.FOTO, id, file, {
                createPreview: 1,
            }).always(function () {
                $this.removeClass('ajax-loader');
                $ajaxLoaderImg.hide();
                $noOriginalImage.show();
                $noOriginalBlock.hide();

            }).done(function (response) {
                if (response.failed) {
                    Fotobook.notification.showError(t('photobook-tooltipText-imageCorrupted'));
                } else {
                    Fotobook.notification.showSuccess(t('photobook-js-photoReplaced'));
                }
            });
        }).catch(() => {});
    },
// ------------------------------------------------------------------------------------
    getUniqueID() {
        const d = new Date;
        return d.getTime().toString(16) + d.getMilliseconds().toString(16) + Math.random().toString(16).slice(2, 6);
    },
    getAvailableLocalIds() {
        const ids = [];
        for (let i=0; i<self.originalFiles.length; i++) {
            ids.push(self.originalFiles[i].id);
        }
        return ids;
    },
    removeOrphanedOriginals() {
        const ids = {};
        $('#added-photos').find('.album_image').each(function () {
            if (this.getAttribute('data-foto_storage_code') === self.CODE_MYCOMPUTER) {
                ids[decodeURIComponent(this.getAttribute('data-swf_file_id'))] = true;
            }
        });
        self.originalFiles = self.originalFiles.filter(function (obj) {
            return ids[obj.id];
        });
    },
    fileSelectorChange(e) {
        const files = Array.from(e.target.files);
        const $target = $(e.target);
        const deferred = $target.data('importdeferred');

        if (deferred) {
            $target.removeData('importdeferred');
            deferred.notify(files);
        } else {
            self.processLocalFiles(files);
            Fotobook.beforeUnload.addCondition(self.localProcessingActive);
        }
    },

    dropFiles(e) {
        const files = Array.from(e.originalEvent.dataTransfer.files);
        self.removeLocalUploadBars(['error', 'warning']);
        self.processLocalFiles(files);
    },

    /**
     * Предупреждающее окно о загрузке файлов более допустимого кол-ва
     *
     * @returns promise
     */
    tooManyFilesWarning() {
        return Fotobook.dialog.alert(t('photobook-js-dialog-uplodingWarningContent', {
            max_count : Fotobook.config.data[Fotobook.Settings.MAX_UPLOADING_FILES],
        }), {
            title         : t('photobook-js-warning'),
            width         : 400,
            buttonResolve : t('photobook-js-buttonsContinue'),
        });
    },
    applyMaxFilesRestriction(files) {
        if (files.length > Fotobook.config.data[Fotobook.Settings.MAX_UPLOADING_FILES]) {
            files = files.slice(0, Fotobook.config.data[Fotobook.Settings.MAX_UPLOADING_FILES]);
            self.tooManyFilesWarning();
        }
        return files;
    },

    /**
     * Проверить наличие места надиске
     * @todo выделить в QuotaManager в модуль user
     *
     * @param {int} size Размер фала для загрузки
     * @returns {*}
     */
    checkQuota(size) {
        return Fotobook.ajax.postHTML('/user/quota/check', {
            data : {
                size,
            },
        }).then((response) => {
            if (response) {
                Fotobook.quota.dialog(response);
                throw response;
            }
        });
    },
    async processLocalFiles(files) {
        const objects = await self.filterLocalFiles(files);

        this.resizeAndUploadPreviews(objects);
    },

    fileAdded(obj) {
        for (let i=0; i<self.originalFiles.length; i++) {
            if (obj.file.name === self.originalFiles[i].file.name) {
                obj.already_loaded_id = self.originalFiles[i].id;
                return true;
            }
        }
        return false;
    },
    markLocalFilesForUpload(swf_id_map) {
        for (let i=0; i<self.originalFiles.length; i++) {
            const obj = self.originalFiles[i];
            if (swf_id_map.hasOwnProperty(obj.id)) {
                obj.swf_id_map = swf_id_map[obj.id];
            }
        }
    },
    /**
     * Переводим значение лимита по загрузке (в байтах) в человеко-понятный формат (мегабайты)
     * @param bytes int
     * @return {string}
     * @private
     */
    _bytesToMegabytes(bytes) {
        return (bytes / 1e+6).toFixed(2);
    },

    getLocalFileError(obj, quotaInfo, quotaUsed) {
        const usedByUser = quotaInfo.usedByUser + quotaUsed;
        const usedByDepartmment = quotaInfo.usedByDepartment + quotaUsed;
        if (!Fotobook.fileReaderFilter.test(obj.file.type)) {
            return {
                class: 'autotest-image-upload-error-invalidFileFormat',
                type: 'error',
                text: t('photobook-error-invalidFileFormat'),
            };
        }

        if (obj.file.size > Fotobook.config.data[Fotobook.Settings.MAX_FILE_SIZE]) {
            return {
                class: 'autotest-image-upload-warning-maxFileSize',
                type: 'warning',
                text: t('photobook-js-file-maxFilesizeInMb', {
                    megabytes: self._bytesToMegabytes(Fotobook.config.data[Fotobook.Settings.MAX_FILE_SIZE]),
                }),
            };
        }

        // if departmentQuota === null - ignore quota
        if (quotaInfo.departmentQuota && usedByDepartmment + obj.file.size > quotaInfo.departmentQuota) {
            Fotobook.dialog.alert(t('photobook-js-notificationDepartmentQuotaExceeded'));
            Fotobook.$http.post('/photos/import/quota-exceeded');
            return {
                class: 'autotest-image-upload-error-quotaExceeded',
                type: 'critical',
                text: t('photobook-js-notificationQuotaExceeded'),
            };
        }

        if (usedByUser + obj.file.size > quotaInfo.userQuota) {
            return {
                class: 'autotest-image-upload-error-quotaExceeded',
                type: 'error',
                text: t('photobook-js-notificationQuotaExceeded'),
            };
        }

        if (self.fileAdded(obj)) {
            return {
                class: 'autotest-image-upload-warning-alreadyAttached',
                type: 'warning',
                text: t('photobook-js-file-attached'),
            };
        }

        return false;
    },

    async filterLocalFiles(files) {
        // квота - параметр динамический, её получение на данный момент асинхронное, поэтому
        // получаем её 1 раз здесь, в дочернюю функцию передаём значение
        // fixme продумать апи и как обновлять квоту - как ограничение, так и объём,
        // использованный юзером. Вероятно, это всё переедет во vuex
        const quotaInfo = await Fotobook.quota.getInfo();
        let totalProcessedBytes = 0;
        return files.slice(0).reduce((objects, file, i, arr) => {
            const obj = {
                id: this.getUniqueID(),
                file,
            };
            totalProcessedBytes += obj.file.size;
            const error = self.getLocalFileError(obj, quotaInfo, totalProcessedBytes);

            if (error) {
                this.appendWarningBar(obj, error);
                if (error.type === 'critical') {
                    arr.splice(0); // break the cycle
                }
            } else {
                objects.push(obj);
                self.appendFileProgressBar(obj, {
                    class: '',
                    type: 'success',
                    text: '',
                });
            }
            return objects;
        }, []);
    },

    getResizeDimensions(info) {
        const r = {
                width : 0,
                height : 0,
            };
        const t_width = Fotobook.config.data.uploader.resize_width;
        const t_height = Fotobook.config.data.uploader.resize_height;

        if (info.width > 0 && info.height > 0) {
            const ks = info.width/info.height;
            const kd = t_width/t_height;
            if (ks > kd) {
                r.width = Math.min(t_width, info.width);
                r.height = Math.round(r.width/ks);
            } else {
                r.height = Math.min(t_height, info.height);
                r.width = Math.round(r.height*ks);
            }
        }
        return r;
    },
    generateFormData(data) {
        const fd = new FormData();

        for (const key in data) {
            if (!data.hasOwnProperty(key)) {
                continue;
            }
            const value = data[key];
            if (value.filename) {
                const binary = new Uint8Array(value.data.length);
                for (let i=0, l=value.data.length; i<l; i++) {
                    binary[i] = value.data.charCodeAt(i);
                }
                fd.append(key, new Blob([binary], {type: value.mimetype}), value.filename);
            } else {
                fd.append(key, value);
            }

        }
        return fd;
    },
    getFileDate(file) {
        if (file.lastModified) {
            return new Date(file.lastModified);
        }
        if (file.lastModifiedDate) {
            return file.lastModifiedDate;
        }
        return '';
    },
    successDataUrlLoaded(obj, img) {
        let data,
            info = {
                width  : img.naturalWidth,
                height : img.naturalHeight,
            },
            fileType = obj.file.type || 'image/jpeg',
            canvas = self.canvas.get(),
            context = canvas.getContext('2d'),
            dims = self.getResizeDimensions(info),
            file = obj.file;

        canvas.width = dims.width;
        canvas.height = dims.height;
        try {
            context.drawImage(img, 0, 0, canvas.width, canvas.height);
            data = self.generateFormData({
                uid       : obj.id,
                orig_size : file.size,
                width     : info.width,
                height    : info.height,
                created   : self.getFileDate(file).toString(),
                image : {
                    filename : file.name,
                    mimetype : fileType,
                    data : atob(canvas.toDataURL(fileType).replace(/^data:image\/[a-z]+;base64,/, '')),
                },
            });
        } catch (e) {
            Fotobook.debug('Canvas error: ',e);
            obj.error = t('photobook-js-error-reading-file');
            data = false;
        }
        self.canvas.free();
        obj.data = data;
    },

    _sizeToMegapixels(img) {
        return (img.naturalHeight * img.naturalWidth)/1000000;
    },

    createOnePreview(obj) {
        const img = self.img.get();
        const promise =  new Promise((resolve) => {
            obj.type = 'error';
            if (self.aborted) {
                obj.error = t('photobook-js-error-cancelUploading-file');
                obj.class = 'autotest-image-upload-error-uploadingCanceled';
                resolve(obj);
                return;
            }
            img.onload = (e) => {
                if (self._sizeToMegapixels(img) > Fotobook.config.data[Fotobook.Settings.MAX_FILE_SIZE_IN_MEGAPIXELS]) {
                    Fotobook.debug('Error: ', e, obj);
                    obj.error = t('photobook-js-file-maxFilesizeInMp', {
                        megapixels: Fotobook.config.data[Fotobook.Settings.MAX_FILE_SIZE_IN_MEGAPIXELS],
                    });
                    obj.class = 'autotest-image-upload-error-resolutionExceed';
                    Fotobook.notification.showWarning(obj.error);
                } else {
                    self.successDataUrlLoaded(obj, img);
                }
                resolve(obj);
            };
            img.onerror = (e) => {
                Fotobook.debug('Error: ', e, obj);
                obj.error = t('photobook-js-error-reading-file');
                obj.class = 'autotest-image-upload-error-readFileError';
                Fotobook.notification.showWarning(obj.error);
                resolve(obj);
            };
            img.src = window.URL.createObjectURL(obj.file);
        });
        promise.finally(() => self.img.free());
        return promise;
    },
    createPreviews(objects) {
        var deferred = $.Deferred(),
            queue = objects.slice(),
            queueCreatePreview = function () {
                if (!queue.length) {
                    deferred.resolve();
                    return;
                }
                const obj = queue.shift();
                setTimeout(function () {
                    self.createOnePreview(obj).then((obj) => {
                        deferred.notify(obj);
                        queueCreatePreview();
                    });
                }, 0); // Без таймаута ИЕ не может обработать несколько изображений подряд
            };

        setTimeout(queueCreatePreview, 0);
        return deferred.promise();
    },
    /**
     * Помещаем в одну функцию из-за сложной логики:
     * ресайз происходит в один поток, но непрерывно,
     * в то время, как результаты ресайза обрабатываются параллельно
     * ограниченным количеством потоков
     */
    resizeAndUploadPreviews(objects) {
        return new Promise((resolve) => {
            let threads = 0,
                queue = [],
                queue_full = false,
                // счётчики для футера окна загрузки
                counters = {
                    preloaded : self.originalFiles.length,
                    total     : objects.length,
                    loaded    : 0,
                    skipped   : 0,
                    left      : objects.length,
                },

                resolveCheck = function () {
                    if (queue_full && !threads) {
                        resolve();
                    }
                },
                // Аякс-очередь в Fotobook.config.data[Fotobook.Settings.PREVIEW_QUEUE_SIZE] параллельных потоков
                queuePreviewAjaxUpload = function () {
                    if (threads >= Fotobook.config.data[Fotobook.Settings.PREVIEW_QUEUE_SIZE] || !queue.length) {
                        return;
                    }
                    const obj = queue.shift();
                    threads++;
                    self.ajaxUploadOnePreview(obj).then(() => {
                        self.animateLocalProgressBar(obj);
                        self.originalFiles.push(obj);
                        counters.loaded++;
                    }).catch(() => {
                        self.appendWarningBar(obj, {
                            class: obj.class,
                            type: obj.type,
                            text: obj.error,
                        });
                        counters.skipped++;
                    }).finally(() => {
                        threads--;
                        counters.left--;
                        self.updateFooterCounters(counters);
                        queuePreviewAjaxUpload();
                        resolveCheck();
                    });
                };

            self.updateFooterCounters(counters);

            // Создаём превью в один поток, через прогресс запускаем аякс-очередь
            self.aborted = false;
            self.setLocalProcessingActive(true);
            self.createPreviews(objects).progress((obj) => {
                queue.push(obj);
                queuePreviewAjaxUpload();
            }).done(() => {
                queue_full = true;
                resolveCheck();
                self.setLocalProcessingActive(false);
            });
        });
    },

    ajaxUploadOnePreview(obj) {
        if (Fotobook.aborted || !(obj.data instanceof FormData)) {
            if (Fotobook.aborted) {
                obj.error = t('photobook-js-error-cancelUploading-file');
            }
            return Promise.reject();
        }
        return Fotobook.ajax.postJSON('/photos/import/create-session-foto-from-preview', {
            data : obj.data,
            contentType: false,
            type : 'post',
            dataType : 'json',
            processData : false,
        }).then((response) => {
            obj.session_foto = response.data;
            self.updateSessionFotosLayout([response.data]);
        });
    },
    updateFooterCounters(data) {
        const $footer = $('#fotobookUploaderFooter');
        $footer.find('#fotobookTotal').text(data.total + data.preloaded);
        $footer.find('#fotobookLoaded').text(data.loaded + data.preloaded);
        $footer.find('#fotobookSkipped').css({display : data.skipped ? 'inline' : 'none'}).find('span').text(data.skipped);
        $footer.find('#fotobookLeft').text(data.left);
        $footer.toggleClass('visible', data.total + data.preloaded > 0);
    },
    getFooterCounters() {
        const $footer = $('#fotobookUploaderFooter');
        return {
            total   : parseInt($footer.find('#fotobookTotal').text(), 10) || 0,
            loaded  : parseInt($footer.find('#fotobookLoaded').text(), 10) || 0,
            skipped : parseInt($footer.find('#fotobookSkipped').text(), 10) || 0,
            left    : parseInt($footer.find('#fotobookLeft').text(), 10) || 0,
            preloaded : 0,
        };
    },

    resetFormElement(e) {
        e.wrap('<form>').closest('form').get(0).reset();
        e.unwrap();
    },
    removeFile(id) {
        const counters = self.getFooterCounters();
        for (let i = 0; i < self.originalFiles.length; i++) {
            if (self.originalFiles[i].id === id) {
                self.originalFiles.splice(i,1);
                counters.total = Math.max(counters.total-1, 0);
                counters.loaded = Math.max(counters.loaded-1, 0);
                self.updateFooterCounters(counters);
                break;
            }
        }
        self.removeLocalUploadBarById(id);
    },

    reinitLocalProgressBarsJsp() {
        const $info = $('#fotobookUploaderInfo');
        $info.reinitJsp();
        $info.closest('.available-mypc-area').toggleClass('empty', !$info.find('.local-uploader-bar').length);
    },
    escapeForId(id) {
        const hex = [];
        for(let i=0;i<id.length;i++) {
            hex.push(id.charCodeAt(i).toString(16));
        }
        return hex.join('');
    },
    animateLocalProgressBar(obj) {
        const $bar = $(`#id-${self.escapeForId(obj.id)}`);
        $bar.addClass('file-uploading');
        $bar.find('.success').animate({
            width: '100%',
        }, () => {
            $bar.removeClass('file-uploading').addClass('file-uploaded');
            self.reinitLocalProgressBarsJsp();
        });
    },
    removeLocalUploadBarById(id) {
        $(`#id-${self.escapeForId(id)}`).remove();
        $(`.already-loaded-${self.escapeForId(id)}`).remove();
        self.reinitLocalProgressBarsJsp();
    },
    removeLocalUploadBars(classes) {
        let $bars = $('.local-uploader-bar');
        if (classes.length) {
            $bars = $bars.filter(`.${classes.join(',.')}`).remove();
        }
        $bars.remove();
        self.reinitLocalProgressBarsJsp();
    },

    _preview_progress_bar_tpl: [
        '<li id="id-{id}" class="local-uploader-bar {type} {class} already-loaded-{already-loaded-id}">',
            '<div class="fotobookUploaderFileName" title="{filename}">{filename}</div>',
            '<div class="fotobookUploaderCurrentProgress"><span class="{type}"><span>{text}</span></span></div>',
        '</li>',
    ].join(''),

    appendFileProgressBar(fileObject, statusObject) {
        let $old = $(`#id-${self.escapeForId(fileObject.id)}`),
            bar = self._preview_progress_bar_tpl.supplant({
                id : self.escapeForId(fileObject.id),
                filename : fileObject.file.name,
                ...statusObject,
                'already-loaded-id' : self.escapeForId(fileObject.already_loaded_id || 'none'),
            });
        if ($old.length) {
            $old.replaceWith(bar);
        } else {
            $('#fotobookUploaderFileList').append(bar);
        }
        self.reinitLocalProgressBarsJsp();
    },

    appendWarningBar(fileObject, statusObject) {
        self.appendFileProgressBar(fileObject, statusObject);
    },

    backgroundUpload(data) {
        return Fotobook.$http.get('/photos/import/get-provider-background-pending', {
            params: {
                clipartClass: data['class'],
            },
        }).then((response) => {
            data = data || {};
            data.providers_items = response.data.items;
            return self.startBackgroundUpload(data);
        });
    },
        storeUploadStart(data) {
            Fotobook.store.commit('BgUploader/bgUploadStart');

            // все изображения считаем загружаемыми для того, чтобы с ним можно было работать
            // если будут проблемы с "залипанием" статуса - надо будет выяснять, как это происходит
            // статус со всех объектов должен сняться внутри потока загрузки
            self.triggerUploadStarted(data['class'], self.originalFiles.map((obj) => {
                return obj.swf_id_map.id;
            }));

            const originalItems = self.originalFiles.map((obj) => {
                return {
                    clipartClass: obj.swf_id_map.class,
                    id: obj.swf_id_map.id,
                    albumId: obj.swf_id_map.albumId,
                };
            });

            const remoteItems = data.providers_items.map((item) => {
                return {
                    clipartClass: item.clipartClass,
                    id: item.id,
                    albumId: item.albumId,
                };
            });


            Fotobook.store.commit('BgUploader/bgUploadQueueItems', [
                ...originalItems,
                ...remoteItems,
            ]);
        },
        startBackgroundUpload(data) {
            if (!data['class']) {
                data['class'] = Fotobook.ClipartType.FOTO;
            }

            const deferred = $.Deferred();
            self.setBackgroundUploadActive(true);
            this.storeUploadStart(data);

            // Сначала загружаются оригиналы с локального компьютера, по окончании запускается
            // фоновая загрузка с провайдеров
            self.backgroundLocalUpload(data['class']).done(() => {
                if (!data.providers_items.length) {
                    deferred.resolve();
                } else {
                    self.backgroundProviderUpload(data).done(deferred.resolve);
                }
            });
            return deferred.done(() => {
                self.setBackgroundUploadActive(false);
                self.uploadComplete();
            }).promise();
        },

        /**
         * Многопоточный загрузчик оригиналов
         */
        backgroundLocalUpload(clipartClass) {
            let threads = 0;

            const deferred = $.Deferred();
            const resolveCheck = () => {
                if (!threads && !self.originalFiles.length) {
                    deferred.resolve();
                }
            };
            const startNewThread = () => {
                if (threads >= Fotobook.config.data[Fotobook.Settings.MYCOMP_UPLOAD_ORIG_THREADS] || !self.originalFiles.length) {
                    return;
                }
                const obj = self.originalFiles.shift();
                threads++;
                self.backgroundUploadThread(obj, clipartClass).done(() => {
                    threads--;
                    startNewThread();
                    resolveCheck();
                });
            };

            for (let i = 0, maxx = Math.min(Fotobook.config.data[Fotobook.Settings.MYCOMP_UPLOAD_ORIG_THREADS], self.originalFiles.length); i < maxx; i++) {
                startNewThread();
            }
            resolveCheck();

            return deferred.promise();
        },

        /**
         * Один поток фоновой загрузки оригиналов
         */
        backgroundUploadThread(obj, clipartClass) {
            const deferred = $.Deferred();
            const promise = deferred.promise();

            if (!obj.swf_id_map || obj.swf_id_map['class'] !== clipartClass) {
                deferred.resolve();
                return promise;
            }

            const form = new FormData();
            const id = obj.swf_id_map.id;

            form.append('id', id);
            form.append('class', clipartClass);
            form.append('image', obj.file, obj.file.name);

            Object.entries(obj.addParams || {}).forEach(([name, value]) => {
                form.append(name, value);
            });

            const changeStatusPayload = {
                clipartClass: obj.swf_id_map['class'],
                id,
            };

            Fotobook.store.commit('BgUploader/bgUploadChangeStatus', {
                ...changeStatusPayload,
                status: Fotobook.UploadingStatus.UPLOADING,
            });
            self.triggerUploadStarted(obj.swf_id_map['class'], [id]);
            Fotobook.ajax.postJSON('/photos/import/bg-upload-local', {
                data: form,
                contentType: false,
                type: 'post',
                dataType: 'json',
                processData: false,
                queue: false,
                timeout: 0,
            }).then((response) => {
                deferred.resolve(response.data);
                Fotobook.store.commit('BgUploader/bgUploadChangeStatus', {
                    ...changeStatusPayload,
                    status: response.data.loaded ? Fotobook.UploadingStatus.SUCCESS : Fotobook.UploadingStatus.ERROR,
                });
                if (response.data.clipart_class === Fotobook.ClipartType.FOTO) {
                    const fotoManagerUpdate = response.data.clipart.map((foto) => {
                        return {
                            class: Fotobook.ClipartType.FOTO,
                            item: foto,
                        };
                    });
                    Fotobook.store.commit('FotoManager/updateData', fotoManagerUpdate);
                }
                self.triggerUploadEnded(clipartClass, [id]);
            }).catch((error) => {
                deferred.resolve();
                Fotobook.store.commit('BgUploader/bgUploadChangeStatus', {
                    ...changeStatusPayload,
                    status: Fotobook.UploadingStatus.ERROR,
                });
                self.triggerUploadEnded(clipartClass, [], [id]);
            });

            return promise;
        },

        /**
         * Фоновая загрузка фото с провайдеров
         *
         * @param data
         * @returns {*}
         */
        backgroundProviderUpload(data) {
            const deferred = $.Deferred();
            let successIds = [];

            self.triggerUploadStarted(data['class'], data.providers_items);
            data.providers_items.forEach((item) => {
                Fotobook.store.commit('BgUploader/bgUploadChangeStatus', {
                    clipartClass: item.clipartClass,
                    id: item.id,
                    status: Fotobook.UploadingStatus.UPLOADING,
                });
            });

            Fotobook.ajax.postJSON('/photos/import/bg-upload-provider', {
                data,
                timeout: 0,
                queue: false,
            }).then((response) => {
                deferred.notify(response.data);
                if (response.data.quota) {
                    self.displayQuotaMessage(response.data.message);
                }
                successIds = response.data.loaded_ids;
            }).catch(() => {
            }).finally(() => {
                const failIds = data.providers_items.filter((item) => !successIds.includes(item.id));
                data.providers_items.forEach((item) => {
                    const status = successIds.includes(item.id) ? Fotobook.UploadingStatus.SUCCESS : Fotobook.UploadingStatus.ERROR;
                    Fotobook.store.commit('BgUploader/bgUploadChangeStatus', {
                        clipartClass: item.clipartClass,
                        id: item.id,
                        status,
                    });
                });
                deferred.resolve();
                self.triggerUploadEnded(data['class'], successIds, failIds);
            });
            return deferred.promise();
        },

        displayQuotaMessage(message) {
            return Fotobook.dialog.alert(message || t('photobook-js-quota-leftOnUpload'), {
                title         : t('photobook-js-quota-left'),
                width         : 400,
                buttonResolve : t('photobook-js-buttonsDialogOk'),
            });
        },

        /**
         * Действия по завершению загрузки
         * это всё необходимо переделать на события
         */
        uploadComplete() {
            if (Fotobook.onlineEditorActive()) {
                Fotobook.core.getAlbumFotos();

                Fotobook.store.dispatch('bottomPanel/updateControls');
                // Fotobook.bottomPanel.updateBottomControls();

                Fotobook.ajax.post('/photos/import/update-after-upload').then((response) => {
                    Fotobook.book.updateBookFromResponse(response.data.state);
                });
                this.checkBrokenPhotosFromInstagram();
            }
        },

        /**
         * Если аккаунт Instagram пользователя приватный то приложение не может получить валидную ссылку
         * на фото в максимальном разрешении, как итог фото - битые. Фото меньшего качества не подходят.
         */
        checkBrokenPhotosFromInstagram() {
            if (Fotobook.$cookies.get('foto_storage') !== 'Instagram') {
                return;
            }
            for (let image of Fotobook.fotoManager.imagesTab._images) {
                if (!image.originalExists) {
                    Fotobook.notification.showWarning(t('photobook-instagram-original-missing'));
                    return;
                }
            }
        },

    checkUploadDialogButtons_fun() {
        self.check_upload_dialog_timeout = false;
        const isUploadActive = self.localProcessingActive() || self.backgroundUploadActive();
        const $addedSection = $('.added-fotos-section');
        const fotobookLeftAmount =  !!Number($('#fotobookLeft').text());
        const $uploadPhotoButtons = $('#cancelUploadFotos,#fotobookUpload,.upload-files-label');
        const $uploadFotos = $('#uploadFotos');
        const $abortLocalButton = $('.abort-local-preview-upload');

        $uploadPhotoButtons
            .attr('disabled', fotobookLeftAmount)
            .toggleClass('disabled', fotobookLeftAmount);

        const disabled = isUploadActive || !$addedSection.find('.photo').length;
        const uploadBtnDisabled = fotobookLeftAmount || isUploadActive;

        $uploadFotos
            .attr('disabled', uploadBtnDisabled)
            .toggleClass('disabled', uploadBtnDisabled);

        $abortLocalButton
            .toggleClass('disabled', !isUploadActive)
            .toggle(isUploadActive);

        $addedSection.find('.remove-all-button').attr('disabled', disabled).toggleClass('disabled', disabled);
    },

    checkUploadDialogButtons() {
        if (!self.check_upload_dialog_timeout) {
            self.check_upload_dialog_timeout = setTimeout( () => {
                self.checkUploadDialogButtons_fun();
            }, 0);
        }
    },

    // вызов этого события перекрыт более ранними вызовами - разобраться !
    beforeUnload() {

        let message;

        // в визарде загрузка будет молча прервана, в редакторе переспросим пользователя
        if (Fotobook.onlineEditorActive()) {
            if ($('#import').length && self.originalFiles.length) {
                message = t('photobook-js-warning-lostphoto2');
            }

            if (self.backgroundUploadActive()) {
                message = t('photobook-js-warning-lostphoto');
            }
        }

        if (!!message) {
            Fotobook.notification.showWarning(message);
        }

        return message;
    },

    isUploadingNow(clipart_class, id) {
        const uploading = self.uploading[clipart_class];
        return !!(uploading && uploading[id]);
    },

        triggerUploadStarted(clipartClass, ids) {
            let filteredIds = [];
            ids.forEach((element) => {
                const id = typeof element === 'number' ? element : element.id;
                if (!self.isUploadingNow(id)) {
                    filteredIds.push(id);
                }
            });

            if (!filteredIds.length) {
                return;
            }

            $(document).trigger(Fotobook.events.ORIGINAL_UPLOAD_START, {
                clipart_class: clipartClass,
                ids: filteredIds,
            });
        },

    /**
     * Бросить событие о завершениии загрузки фото
     *
     * @param clipart_class
     * @param successIds
     * @param failIds
     * @param error_code
     */
    triggerUploadEnded(clipart_class, successIds, failIds = []) {
        const ids = {};

        successIds = successIds.filter(function (id) {
            return self.isUploadingNow(clipart_class, id);
        });

        failIds = failIds.filter(function (id) {
            return self.isUploadingNow(clipart_class, id);
        });

        successIds.forEach((id) => {
            ids[id] = true;
        });

        failIds.forEach((id) => {
            ids[id] = false;
        });

        // в будущем пересмотреть
        if (clipart_class !== Fotobook.ClipartType.FOTO) {
            Fotobook.store.dispatch('userClipart/updateUserClipart');
        }
        $(document).trigger(Fotobook.events.ORIGINAL_UPLOAD_END, {
            clipart_class,
            ids,
            success: successIds,
            fail: failIds,
        });
    },

    /**
     * Удалить пользовательские клипарт/фото
     */
    deleteUserClipart(data) {
        return Fotobook.ajax.postJSON('/photos/get-clipart-usage', {
            data,
        }).then((response) => {
            let used = response.data.current + response.data.others,
                text = t(used ? 'photobook-js-removeUsedPhotoQuestion' : 'photobook-js-removePhotoQuestion');

            return Fotobook.dialog.confirm(text, {
                title: t('photobook-js-removePhotoDialogTitle'),
            });
        }).then(() => {
            const $dialog = Fotobook.dialog.alert(t('photobook-js-fotosDeleting') + Fotobook.projectChecking, {
                title: t('photobook-js-removePhotoDialogTitle'),
                showButtonResolve: false,
            });
            const promise = self.deleteClipart(data).then((response) => {
                if (response.data.not_deleted) {
                    Fotobook.dialog.alert(t('photobook-js-someElementsWereNotDeleted'));
                }
                Fotobook.fotoManager.afterDel(response.data.deleted);
            });
            promise.finally(() => {
                $dialog.dialog('close');
            });
            return promise;
        });
    },

    deleteClipart(data) {
        return Fotobook.ajax.postJSON('/photos/delete-clipart', {
            data : {
                data,
            },
        }).then((response) => {
            if (Fotobook.book.project.id) {
                Fotobook.isModified = true;
                if (response.data.state) {
                    Fotobook.book.initState(response.data);
                }
                const deleted = response.data.deleted;
                // todo бросать событие, обрабатывать в соответствующем модуле
                if (deleted[Fotobook.ClipartType.FOTO]) {
                    for (let i = 0; i < response.data.deleted[Fotobook.ClipartType.FOTO].length; i++) {
                        Fotobook.bottomPanel.fotosTab.removeImage(response.data.deleted[Fotobook.ClipartType.FOTO][i]);
                    }
                }
                if (deleted[Fotobook.ClipartType.ARTEFACT] || deleted[Fotobook.ClipartType.FRAME] || deleted[Fotobook.ClipartType.MASK]) {
                    Fotobook.store.dispatch('userClipart/updateUserClipart');
                }
            }
            return response;
        });
    },

    init() {
        self.ajaxReloadImport();
        self.removeOrphanedOriginals();
    },

        async acceptLicense(storageCode) {
            if (storageCode !== Fotobook.ProviderCode.GOOGLE_PHOTOS) {
                return true;
            }
            return Fotobook.provider.acceptGooglePhotosPolicy().then(() => {
                Fotobook.store.commit('user/setGooglePhotoPolicyAccepted', true);
                return true;
            }).catch(() => {
                return false;
            }).finally(() => {
                $('.gppDialog').remove();
            });
        },
        providerClick(element) {
            const stepsLeftMenu = $('#steps-left-menu');
            if (stepsLeftMenu.hasClass('ui-state-disabled')) {
                return false;
            }
            const $this = $(element);
            const storageCode = $this.attr('data-provider');

            return self.acceptLicense(storageCode).then((success) => {
                if (!success) {
                    return;
                }
                if ($this.hasClass('not-connected') && !$this.parent().hasClass('pc-provider')) {
                    // Обработка нажатия неподключенного провайдера
                    stepsLeftMenu.find('.provider.not-connected').removeClass('to-connect');
                    const providerCode = $this.attr('data-provider');
                    if (providerCode) {
                        $this.addClass('to-connect');
                        Fotobook.remoteLogin(providerCode).then((remoteProfile) => {
                            if (remoteProfile.identifier) {
                                Fotobook.import.ajaxReloadImport();
                            }
                        });
                    }
                } else {
                    $this.closest('#import').attr('data-storage', storageCode);
                    self.abortPSRequest();
                    if (stepsLeftMenu.hasClass('show-albums')) {
                        const currentStorage = stepsLeftMenu.find('input.foto_storage').val();
                        if (currentStorage === storageCode || storageCode === Fotobook.ProviderCode.MY_PC) {
                            stepsLeftMenu.removeClass('show-albums');
                            self.changeSelFotosHeader(stepsLeftMenu.find('.pc-section .h-name').text());
                            self.fotoStorageRequest(Fotobook.ProviderCode.MY_PC);
                            //инициализация jsp скролла после обновления контента
                            // stepsLeftMenu.find('.auto-jsp').initJsp();
                            return false;
                        }
                    }
                    self.changeSelFotosHeader($this.attr('data-storage-name'));
                    self.fotoStorageRequest(storageCode);
                }
            });
        },
};

Fotobook.UserClipartTypes.forEach((key) => {
    self.uploading[key] = {};
});

$(document)
.on(Fotobook.events.ORIGINAL_UPLOAD_START, function (event, data) {
    for (let i=0, l=data.ids.length; i<l; i++) {
        self.uploading[data.clipart_class][data.ids[i]] = true;
    }
})
.on(Fotobook.events.ORIGINAL_UPLOAD_END, function (event, data) {
    for (const i in data.ids) {
        if (data.ids.hasOwnProperty(i)) {
            delete(self.uploading[data.clipart_class][i]);
        }
    }
})
.on('click', '.added-fotos-section .photo .remove', self.removeAdded)
.on('click', '.add-all-button', self.addAll)
.on('click', '.remove-all-button:not(.disabled)', self.removeAll)

        /** Клик по кнопке провайдера */
        .on('click', '#import .provider', (element) => {
            self.providerClick(element.currentTarget);
        })

// Переключение альбомов
// !!! переделать селектор на классы !!!
.on('click triggered-click.PhotoImport', '.albums-section input[type=radio]', function (e) {
    let album_id = $(this).val(),
        prov = $('#steps-left-menu .ui-accordion-content:visible').find('.foto_storage').val();
    Fotobook.$cookies.set(`${prov}_album`, album_id);
    if (album_id === '') {
        $('#photos-list').empty();
        return false;
    }
    self.updateFotosList({
        album_id,
    });
})
// События дропбокса
.on('click', '.provider-folder, .provider-folder-back', (event) => {
    const $this = $(event.currentTarget);
    let albumId = $this.attr('data-value');
    const prov = $('#steps-left-menu .ui-accordion-content:visible').find('.provider.is-active-storage').attr('data-storage-code');
    Fotobook.$cookies.set(`${prov}_album`, albumId);
    if (albumId === undefined) {
        albumId = $this.attr('data-parent-album-id');
    }
    self.updateFotosList({
        album_id: albumId,
    });
})
// Переход по breadcrumbs-ссилкам
.on('click', '#import .breadcrumbs a', function () {
    const album_id = $(this).data('albumId');
    self.updateFotosList({
        album_id,
    });
    self.doBreadCrumbs();
})
// Переключение выбрана/не выбрана для фото из альбомов провайдеров
.on('click', '.available-fotos-section .selectable .album_image', self.toggleAvailableFoto)
// Так как метод теперь у нас требует post-запроса, приходится передавать переменные таким образом
.on('click', '.available-fotos-section .photo-yiiPager a', function (e) {
    e.preventDefault();
    const searchParams = (new URL(this.href)).searchParams;

    Fotobook.ajax.postHTML('/photos/import/get-session-resources', {
        data: {
            foto_storage: searchParams.get('foto_storage'),
            album_id: searchParams.get('album_id'),
            page: searchParams.get('page') || undefined,
        },
    }).then(self.updateFotosContainer);
})

.on('click', '.abort-local-preview-upload:not(.disabled)', function () {
    this.classList.add('disabled');
    self.aborted = true;
})
.on('click', `${self.uploaderSelector}:not(.disabled)`, function () {
    self.resetFormElement($('#fotobook-uploader-input'));
    self.removeLocalUploadBars(['error', 'warning']);
})
.on('click', `${self.uploaderSelector}.disabled #fotobook-uploader-input, #cancelUploadFotos.disabled`, function (e) {
    e.preventDefault();
    e.stopPropagation();
})
.on('drag dragstart dragend dragover dragenter dragleave drop', '#import', function (e) {
    e.preventDefault();
    e.stopPropagation();
})
.on('drop', '#import[data-storage=mycomputer]', function (e) {
    self.dropFiles(e);
})
.on('change', '#fotobook-uploader-input', function (e) {
    self.fileSelectorChange(e);
})
// обработчик нажатия кнопки загрузки фото с ПК
.on('click', 'label[for=fotobook-uploader-input]', function (e) {
    if ($(this).attr('disabled')) {
        e.preventDefault();
    } else {
        $(`#${this.getAttribute('for')}`).removeData('importdeferred').attr('multiple', 'multiple');
    }
})
.on('click', '.controls-button.upload-foto', self.uploadToContainerClick)
.on('dblclick', '.album-fotos .no-original, .photocollection-photos-list .no-original', self.uploadMissingOriginalClick)
.on('click', '.delete-clipart', function (event) {
    const $clipart = $(this).parent().find('.clipart');
    const data = {
        [$clipart.attr('data-upload-class')] : [$clipart.attr('data-id')],
    };

    self.deleteUserClipart(data);
})
.on('change', '#acceptGpp', (event) => {
    const $this = $(event.currentTarget);
    const $btn = $this.closest('.fotobook-dialog').find('.fotobook-dialogbutton-resolve');
    if ($this[0].checked) {
        $btn
            .attr('disabled', false)
            .removeClass('ui-state-disabled');
    } else {
        $btn
            .attr('disabled', true)
            .addClass('ui-state-disabled');
    }
})
.on('click', '.show-mobile-upload-code', () => {
    const mobileSection =  $('.mobile-upload-section');
    mobileSection.html('');
    mobileSection.append('<div class="mobile-upload-code"></div>');

    Fotobook.store.dispatch('Uploader/requestMobileToken').then((token) => {
        const albumID = Number($('#import').attr('data-album-id')) || 0;
        $('.mobile-upload-code').qrcode(`${window.location.host}/mobileUpload/${token}/${albumID}`);
    });
})
;

/**
 * Обработчик на закрытие окна редактора
 */
Fotobook.beforeUnload.addCondition(function () {
    return ($('#import').length && Fotobook.import.originalFiles.length) || Fotobook.import.backgroundUploadActive();
}, self.beforeUnload);

$(function () {
    if ($('#import').length) {
        self.init();
    }
});

})();
